export default (that) => [
  {
    text: that.$l('INDEX.btn_tips_view') || '查看',
    icon: 'el-icon-view',
    menuType: 'detail',
  },
  {
    text: that.$l('INDEX.btn_tips_edit') || '编辑',
    icon: 'el-icon-edit',
    menuType: 'edit',
    divided: true,
    allow: 'M',
    show: ({ greyFabricStatus }) => greyFabricStatus === 'N',
  },
  {
    text: that.$l('INDEX.btn_tips_del') || '删除',
    icon: 'el-icon-delete',
    menuType: 'delete',
    divided: true,
    allow: 'M',
    show: ({ greyFabricStatus }) => greyFabricStatus === 'N',
  },
]
